import * as React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
const SvgArrowDown = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    props,
    <path d="M17.295 9.295a.998.998 0 0 0-1.41-.001L12 13.17 8.115 9.294a.998.998 0 0 0-1.41 1.411l4.588 4.588a1 1 0 0 0 1.414 0l4.588-4.588a.998.998 0 0 0 0-1.41Z" />
  )
export default SvgArrowDown
